import React, { PureComponent } from 'react'
import { TouchableOpacity, View } from 'react-native'
import { createContainer } from '@dbk-legacy/muster/react'
import Text, { H1 } from '@dbk/ui-text'
import Dropdown from '@dbk/ui-dropdowns'
import debounce from 'lodash/debounce';
import sortBy from 'lodash/sortBy';
import reverse from 'lodash/reverse';
import {
  NavigationListItem,
  NavigationListItemHeader,
  NavigationListItemFooter,
} from '@dbk/ui-list'
import Button from '@dbk/ui-buttons'
import Modal from '@dbk/ui-modal';
import { Close } from '@dbk/ui-icons';
import Search from '@dbk/ui-search';
import SearchWithoutCircleIcon from '../../../common/components/icons/search-without-circle';
import ScrollTopOnMount from '../../../components/common/scroll-top-on-mount'
import styles from './payment-destination.styles'
import { PALETTE, CANADIAN_COUNTRY,ROUTES, WARNING_ICON, KEY_CODE } from '../../../constants';
import { PAYMENT_TYPE , PAYMENT_BENF_SORT_VALUE} from '../constant';
import { ErrorIcon, WarningIcon } from '../../../components/common/icons';
import PaymentTouchableListItem from '../payment-touchable-list-item';
import { LoadingCircle } from '../../../components/common/loading';

const { NEW_DOMESTIC, ADD_BENEFICIARY } = ROUTES.PAYMENT

const DEBOUNCE_TIME = 800;
class PymtDest extends PureComponent {
  state = {
    enableSearch: false,
    pageOffset: 0,
    searchResult: [],
    searchText: '',
    deleteConfirmationModal: false,
    deleteItem: null,
    selectedAssets: null,
    selectedOption: PAYMENT_BENF_SORT_VALUE[0].value,
  }

  async componentDidMount(){
    await this.props.payments.getBeneficiaryList();
  }

  beneficiaryDetail = (row, event) => {
    if((event && event.keyCode && (event.keyCode === KEY_CODE.ENTER_KEY || event.keyCode === KEY_CODE.SPACE_KEY)) || (!event && row.hasOwnProperty("beneficiaryId"  ))){ 
      const beneficiary = Object.assign({}, row)
      beneficiary.beneficiaryName = `${row.firstName} ${row.lastName ? row.lastName : ''}`
      // commented for now, just in case if any issue persist will revert back
      // beneficiary.accountNo = row.accountNo ? row.accountNo : row.ibanNo
      // beneficiary.swiftCode = "18236b17";
      this.props.payments.setSelectedBeneficiaryBank(beneficiary)
      this.props.changePage(NEW_DOMESTIC)
    }
  }

  renderErrorModal = () => {
    const { payments: { errorMsg } } = this.props;
    return(
      <Modal
      isActive
      onClose={() => this.props.payments.setErrorModal(false)}
      content={
        <div className="small-12 row padding-20">
          <div className="column small-1">
            <ErrorIcon width={30} height={30} />
          </div>
          <div className="column small-11">
            <Text secondary>{errorMsg}</Text>
          </div>
        </div>
      }
    />
    )
  }

  handleSearchChange = (text) => {
    const {
      payments: {beneficiaryList}
    } = this.props;
    var resultantArray = [];
    const searchText = text.toUpperCase();
    beneficiaryList.length>0 && beneficiaryList.map(item => {
      const fullName = item.firstName + " "+ item.lastName;
      if((item.ibanNo && item.ibanNo.toUpperCase().includes(searchText)) || (item.accountNo && item.accountNo.toUpperCase().includes(searchText))
          || (item.firstName && fullName.toUpperCase().includes(searchText))){
            resultantArray.push(item);
          }
    });
    this.setState({
      enableSearch: true,
      searchResult: resultantArray,
      searchText: text
    });
  }
  
  componentDidUpdate(prevProps, prevState){
    if(this.props.payments.beneficiaryList !== prevProps.payments.beneficiaryList && this.state.searchText.length > 0){
      this.handleSearchChange(this.state.searchText);
    }
    if(document.querySelector('button.btnDeleteOk')){
      document.querySelector('button.btnDeleteOk').focus();
    }
  }
  addNewBeneficiary = () => {
    const {
      payments: { setSelectedBeneficiaryBank, setIBAN, getCountryList, setSelectedBeneficiaryDetail },
    } = this.props
    setSelectedBeneficiaryBank(null);
    setSelectedBeneficiaryDetail(null); //  set benf details  along with benf id
    setIBAN(true)
    getCountryList({ country: "all-country", isAllCountry: true });
    this.props.changePage(ADD_BENEFICIARY)
  }

  filterBenefCanadianRule = (beneficiaryList) => {
    const {
      payments: { selectedCurrency, paymentType },
    } = this.props;

    if (selectedCurrency && selectedCurrency.tech === CANADIAN_COUNTRY.currencyCode && (paymentType.includes(PAYMENT_TYPE.international))) {
      let modifiedBenfList = [];
      beneficiaryList.length>0 && beneficiaryList.map((item, index)=>{
        if(item.address1 && item.address2 && item.address3 && item.address3.toLowerCase() === 'canada'){
          modifiedBenfList.push(item);
        }
      })
      return modifiedBenfList;
    }
    return this.state.selectedOption ? this.sortData(beneficiaryList) : beneficiaryList;
  }

  // Function called on delete action
  deleteBeneficiary = async (event, item) => {
    if((event && event.keyCode && (event.keyCode === KEY_CODE.ENTER_KEY || event.keyCode === KEY_CODE.SPACE_KEY)) || (event && item)){ 
      event.stopPropagation();
      this.setState({ deleteItem: item.beneficiaryId})
      if(!this.props.payments.templateList){
        // call template list endpoint before showing delete confirmation modal
        await this.props.payments.getTemplateList();
      }
      this.props.payments.setDelConfirmationModal(true);
    }
  }

  // Function called on edit action
  editBeneficiary = (event, item) => {
    const {
      payments: { setSelectedBeneficiaryBank, setIBAN, getCountryList, setIsPymtEditBenef, setSelectedBeneficiaryDetail },
    } = this.props
    if((event && event.keyCode && (event.keyCode === KEY_CODE.ENTER_KEY || event.keyCode === KEY_CODE.SPACE_KEY)) || (event && item)){
      event.stopPropagation();
      const beneficiary = Object.assign({}, item)
      beneficiary.beneficiaryName = `${item.firstName} ${item.lastName ? item.lastName : ''}`;
      item.ibanNo ? setIBAN(true) : setIBAN(false);
      setSelectedBeneficiaryBank(beneficiary);
      setSelectedBeneficiaryDetail(beneficiary);
      this.props.changePage(ADD_BENEFICIARY);
      setIsPymtEditBenef(true);
      getCountryList({ country: "all-country", isAllCountry: true });
    }
  }

  closeModal = () =>{
    this.props.payments.setDelConfirmationModal(false);
    this.setState({ deleteItem: null})
  }

  confirmModal = () => {
    this.props.payments.deleteBeneficiary(this.state.deleteItem);
  }

  // Function called on change of sort items
  onSortChange = (selectedItem) => {
    this.setState({
      selectedAssets: selectedItem, selectedOption: selectedItem
    });
  }

 //  Function to sort the data
  sortData = (listData) => {
    let modifiedData = listData;
    if(this.state.selectedOption === PAYMENT_BENF_SORT_VALUE[1].value){
      modifiedData = sortBy(listData, e => ((e.firstName && e.firstName.toLowerCase()) + (e.lastName && e.lastName.toLowerCase())));  //WMCE-41811
    }else{
      modifiedData = sortBy(listData, "lastAccessed");
      modifiedData = reverse(modifiedData);
    }
    return modifiedData;
  }

  showDeleteConfModal = () =>{
    const { payments : { templateList }} = this.props;
    // check if beneficiary is being used in template or not.
    const isTemplateExist = templateList && templateList.find(e => e.beneficiaryId === this.state.deleteItem);

    const { i18n: { messages }} = this.props;
    return (
      <Modal
        closeButtonLabel="Close"
        isActive={this.props.payments.deleteConfirmationModal && this.state.deleteItem}
        style={styles.modalstyle}
        onClose={this.closeModal}
        header={messages['app.payment.beneficiary.delete.title']}
        content={
          <div className="padding-20">
           {isTemplateExist ? 
            <div className="small-12 row">
            <div className="column small-1">
              <WarningIcon width={WARNING_ICON.width} height={WARNING_ICON.height} color={PALETTE.warning}/>
            </div>
            <div tabIndex={0}className="column small-11 padding-left-10">
              <Text>{messages['app.payment.beneficiary.delete.template.exist']}</Text>
            </div>
          </div> :
          <Text tabIndex={0}>{messages['app.payment.beneficiary.delete']}</Text> }
            <div className="text-right margin-top-20">
              <Button
                tertiary
                onPress={this.closeModal}
                size="large">
                {isTemplateExist ? messages['app.payments.cancelPayment'] :  messages['app.common.alert.no']}
              </Button>
              <Button
                onPress={this.confirmModal}
                className="btnDeleteOk"
                size="large"
                loading={this.props.payments.loading}>
                {isTemplateExist ? messages['app.rmcallback.okMsg'] : messages['app.common.alert.yes']}
              </Button>
            </div>
          </div>
        }
      />)
  }

  render() {
    const {
      i18n: { messages },
      payments: { beneficiaryList, paymentType },
      auth: { addBeneficiaryDisabled }
    } = this.props
    const listData = this.state.enableSearch ? ( this.state.selectedOption ? this.sortData(this.state.searchResult) : this.state.searchResult): this.filterBenefCanadianRule(beneficiaryList)
    const dropdownOptions =[ { value: PAYMENT_BENF_SORT_VALUE[0].value, label: messages['app.payment.beneficiary.sort.label']},
      { value: PAYMENT_BENF_SORT_VALUE[1].value, label: messages['app.payment.beneDetail.beneficiaryName']}]
   
   const validList = listData && listData.length
    return (
      <div className="payment-page__destination row">
        <ScrollTopOnMount/>
        <div>
          <div className="title">
          <H1 tabIndex={0}>{messages['app.payment.pageTitle.selectBeneficiary']}</H1>
          <div className="search--header sort-container">
            <div className='search--container'> </div>
            <div className="sortHeader">
            <div className="sortBy padding-left-10">
              {messages['app.payment.beneficiary.sort']}
              </div></div>
          </div>
          <div className="search--header">
            <div className='search--container'>
              <Search
                role="searchbox"
                value={this.state.searchText}
                size= {"large"}
                iconLeft={<SearchWithoutCircleIcon style = {{paddingLeft: 5}} width={24} height ={24} />}
                iconRight={Close}
                placeholder={messages['app.payment.select.searchBenf']}
                onChange = {debounce(this.handleSearchChange, DEBOUNCE_TIME)}
                className="search-button"
              />
            </div>
            <div className="sortHeader">
            <div className="sortSelect" aria-label={messages['app.payment.filter.beneficiaryDropdown']}>
            <Dropdown
              defaultLabel={false}
              className="large-12"
              size='large'
              fullWidth
              selected={this.state.selectedOption}
              onChange={option => this.onSortChange(option)}
              options={dropdownOptions}
          />
            </div>
            <div className="button__new-beneficiary">
              <Button
                fullWidth
                tertiary={addBeneficiaryDisabled}
                disabled={addBeneficiaryDisabled}
                size="large"
                onPress={this.addNewBeneficiary}
                testID="btn_newBeneficiaryPayment_paymentDestination_test">
                {messages['app.payment.newBeneficiary']}
              </Button>
            </div>
            </div>
            </div>
          </div>
          {this.props.payments.loading &&  <div>
              <LoadingCircle isPage={true}/>
          </div>}
          <div>
            {validList > 0 &&
              listData.map(data => (
                <TouchableOpacity accessible={false} key={data && (data.accountNo + data.ibanNo + data.beneficiaryId)} onPress={(e) =>  this.beneficiaryDetail(data, e)}>
                  <NavigationListItem inverse tabIndex={-1} onClick={() => this.beneficiaryDetail(data)} hasArrow={false} role="link">
                    <PaymentTouchableListItem editItem={(e) => this.editBeneficiary(e, data)} deleteItem={(e) => this.deleteBeneficiary(e, data)} item={data} addBeneficiaryDisabled={addBeneficiaryDisabled} aria-hidden="true">
                    <View onKeyDown={(e) =>  this.beneficiaryDetail(data, e)}>
                    <NavigationListItemHeader tabIndex={data.firstName?"0":"-1"}>
                      {data.firstName + ' ' + (data.lastName ? data.lastName : '')}
                    </NavigationListItemHeader>
                    <NavigationListItemFooter tabIndex={data.address1?"0":"-1"}>
                      <Text secondary style={{color:PALETTE.primaryText}}>{data.address1}{data.address1 && data.address2 ? "-": ""}{data.address2}</Text>
                    </NavigationListItemFooter>
                    <NavigationListItemFooter tabIndex={data.address3?"0":"-1"}>
                      <Text secondary style={{color:PALETTE.primaryText}}>{data.address3}</Text>
                    </NavigationListItemFooter>
                    <NavigationListItemFooter tabIndex={0}>
                      <Text secondary style={{color:PALETTE.primaryText}}>{messages['app.common.portfolio.bonds.account']}: {data.accountNo ? data.accountNo : data.ibanNo}</Text>
                    </NavigationListItemFooter>
                    <NavigationListItemFooter tabIndex={data.bank?"0":"-1"}>
                      <Text secondary style={{color:PALETTE.primaryText}}>{data.bank}{paymentType.includes('domestic') ? (data.ntnlId?(' ('+data.ntnlId+')'):'') : (data.swiftCode?(' ('+data.swiftCode+')'):'')}</Text>
                    </NavigationListItemFooter>
                    <NavigationListItemFooter tabIndex={(data.cityName|| data.country)?"0":"-1"}>
                      <Text secondary style={{color:PALETTE.primaryText}}>{data.cityName}{data.cityName && data.postalCode ? ',': ''}{data.postalCode}{data.country? "-": ""}{data.country}</Text>
                    </NavigationListItemFooter>
                    </View>            
                     </PaymentTouchableListItem>               
                    </NavigationListItem>
                </TouchableOpacity>
              ))}
          </div>
        </div>
        <div className="footer-placeholder"/>
        {this.props.payments.errorModal && this.renderErrorModal()}
        {this.props.payments.deleteConfirmationModal && this.showDeleteConfModal()}
      </div>
    )
  }
}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    changePage: { $call: 'ui.history.push' },
    payments: {
      beneficiaryList: true,
      selectedBeneficiaryBank: true,
      setSelectedBeneficiaryBank: { $set: 'selectedBeneficiaryBank' },
      isIBANSelected: true,
      setIBAN: { $set: 'isIBANSelected' },
      getCountryList: { $call: 'searchCountry' },
      selectedCurrency: true,
      paymentType: true,
      getBeneficiaryList: {$call: 'getBeneficiaryList'},
      errorModal: true,
      setErrorModal: { $set: 'errorModal'},
      isPymtEditBenef: true,
      setIsPymtEditBenef: { $set: 'isPymtEditBenef' },
      deleteBeneficiary: { $call : 'deleteBeneficiary'},
      deleteConfirmationModal: true,
      setDelConfirmationModal: { $set: 'deleteConfirmationModal'},
      loading: true,
      errorMsg: true,
      setSelectedBeneficiaryDetail: { $set :'selectedBeneficiaryDetail'},
      templateList: true,
      getTemplateList: { $call: 'getTemplateList' },
    },
    auth: {
      addBeneficiaryDisabled: true,
    }
  },
})(PymtDest)
